export function ResponseIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none' {...props}>
      <path
        d='M5.99935 9.33464L2.66602 6.0013M2.66602 6.0013L5.99935 2.66797M2.66602 6.0013H6.93268C9.17289 6.0013 10.293 6.0013 11.1486 6.43728C11.9013 6.82077 12.5132 7.43269 12.8967 8.18534C13.3327 9.04099 13.3327 10.1611 13.3327 12.4013V13.3346'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
